export default __webpack_public_path__ + "static/media/nextel-logo.0e1f32b8.png";